import axios from 'axios';

export const baseURL = import.meta.env.VITE_API_URL + '/api';

export const axiosInstance = axios.create({
	baseURL,
});
